export enum LimitToJoinEnum {
  LIMIT = ' LIMIT',
  UNLIMIT = 'UNLIMIT',
}

export const LimitToJoinEnumTypeValue = {
  [LimitToJoinEnum.LIMIT]: 'จำกัด',
  [LimitToJoinEnum.UNLIMIT]: 'ไม่จำกัด',
}
